module.exports = __webpack_public_path__ + "images/tv_moveis.webp";